<template>
  <div class="content-page">
    <div class="main-page">
      <div class="zxfy-titie"></div>
      <div class="main-contentBox">
        <div class="star-title">
          <span class="star"></span>查询编号
        </div>
        <div>
          <div class="search-items search title-no number">
            <div class="title-no-left">
              <div class="search-item">
                <div class="search-label">
                  查询编号：
                </div>
                <div>
                  <div>{{ number }}</div>
                </div>
              </div>
              <div class="search-item">
                <div class="search-label">
                  查询密码：
                </div>
                <div>{{ rePassword }}</div>
              </div>
              <div v-if="inquireInfo.applyTime" class="search-item">
                <div class="search-label">
                  到达时间：
                </div>
                <div>{{ $moment(inquireInfo.applyTime).format('YYYY年MM月DD日 HH : mm') }}</div>
              </div>
              <div v-if="status === 5" class="search-item">
                <div class="search-label">
                  撤回时间：
                </div>
                <div>{{ $moment(inquireInfo.revocationTime).format('YYYY年MM月DD日 HH : mm') }}</div>
              </div>
              <div v-if="status === 9" class="search-item">
                <div class="search-label">
                  退回时间：
                </div>
                <div>{{ $moment(inquireInfo.returnTime).format('YYYY年MM月DD日 HH : mm') }}</div>
              </div>
            </div>
            <div v-if="status === 5" class="title-no-right reback">已撤回
            </div>
            <div v-if="status === 9" class="title-no-right reback">已退回
            </div>
          </div>
        </div>
        <div class="star-title">
          <span class="star"></span>申请人信息
        </div>
        <div class="addPerson">
          <div class="addPerson-btn"> 个人（{{ countGR }}）</div>
          <div class="addPerson-btn"> 法人（{{ countFR }}） </div>
        </div>
        <!-- 申请人 -->
        <div class="form-common">
          <div v-for="(item, index) in applicantInfo" :key="index" class="appinfo-box">
            <div class="typeTitle">
              <div class="typeTitle-name"> {{ item.applicantCategory == '1' ? '个人' : '法人' }} </div>
            </div>
            <div class="search-items applicat-search-items">
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />{{ item.applicantCategory == '1' ? '姓名：' : '单位名称：' }}
                </div>
                <el-tooltip :content="item.applicantName" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.applicantName || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />性别：</div>
                {{ item.gender === '0' ? '女' : '男' }}
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '2'">
                <div class="search-label"><i class="i-required" />法人代表：</div>
                <el-tooltip :content="item.legalRepresentative" class="column-content" effect="light"
                  placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.legalRepresentative || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />国家：</div>
                <span class="contry">{{ item.countryCode }}</span>
              </div>
              <div class="search-item col1-3" v-show="item.applicantCategory == '2'">
                <div class="search-label"><i class="i-required" />法人代表职务：</div>
                <el-tooltip :content="item.legalRepresentativeDuty" class="column-content" effect="light"
                  placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.legalRepresentativeDuty || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />证件类型：</div>
                {{ item.identificationTypeCode }}
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />证件号码：</div>
                <span class="Identification">{{ item.identificationCard }}</span>
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />证件材料 (图片)：</div>
                <el-tooltip :content="item.originName" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText" style="width:50%">
                    {{ item.originName || '' }}
                  </div>
                </el-tooltip>
                <span class="download-btn download-btn1" @click="downLoad(item)"> 下载 </span>
                <span @click="handlePreview(item)" class="download-btn"> 预览 </span>
              </div>
              <div class="search-item col1-3 birthday" v-show="item.applicantCategory == '1'">
                <div class="search-label"><i class="i-required" />出生日期：</div>
                {{ $moment(item.bornDate).format('YYYY年MM月DD日') }}
              </div>
              <div v-if="item.applicantCategory == '1'" class="search-item col1-3">
                <div class="search-label"><i class="i-required" />手机号码：</div>
                {{ item.phone }}
              </div>
              <div v-if="item.applicantCategory == '2'" class="search-item col1-3 phoneNumber">
                <div class="search-label"><i class="i-required" />手机号码：</div>
                {{ item.phone }}
              </div>
              <div class="search-item col1-3 phone">
                <div class="search-label">座机号码：</div>
                <span class=" landline">{{ item.telephone }}</span>
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />文书送达地址：</div>
                <el-tooltip :content="item.deliveryAddr" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.deliveryAddr || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />送达地邮编：</div>
                {{ item.deliveryPostcode }}
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />{{ item.applicantCategory == '1' ? '居住地址：' : '公司地址：'
                }}
                </div>
                <el-tooltip :content="item.addr" class="column-content" effect="light" placement="top-start">
                  <div class="search-input ellipsisText">
                    {{ item.addr || '' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="search-item col1-3">
                <div class="search-label"><i class="i-required" />{{ item.applicantCategory == '1' ? '居住地邮编：' : '公司邮编：'
                }}
                </div>
                {{ item.postcode }}
              </div>
            </div>
          </div>
        </div>
        <!-- 被申请人信息 -->
        <div class="star-title">
          <span class="star"></span>被申请人信息
        </div>
        <div class="search-items info">
          <div class="search-item col1-1">
            <div class="search-label">
              <i class="i-required" />复议机关：
            </div>
            {{ inquireInfo.reconsiderationAgencyName }}
          </div>
          <div class="search-item ">
            <div class="search-label">
              <i class="i-required" />被申请人信息：
            </div>
            <div class="respondentInfo-box">
              <div v-for="(item, index) in respondentInfo" :key="index">
                <span>{{ item.respondentName }} </span>
                <span v-show="index !== respondentInfo.length - 1">、</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 行政复议请求 -->
        <div class="star-title">
          <span class="star"></span>行政复议请求
        </div>
        <div class=" search-items search">
          <div class="search-item ">
            <div class="search-label">请求类型：
            </div>
            {{ applyInfo.actCategory === '1' ? '不服行政不作为' : '不服具体行政行为' }}
            <span v-show="applyInfo.specificActType && applyInfo.actCategory === '2'" style="marginLeft:15px">
              {{ applyInfo.specificActType === '1' ? '请求撤销具体行政行为' : '请求确认具体行政行为违法' }}
            </span>
          </div>
          <div class="search-item">
            <div class="search-label">请求内容：
            </div>
            {{ applyInfo.applyType }}
          </div>
        </div>
        <!-- 事实和理由 -->
        <div class="star-title reason">
          <span class="star"></span>事实和理由
        </div>
        <div class=" search-items search">
          <div class="search-item">
            <div class="search-label">
              事实和理由：
            </div>
            {{ applyInfo.factsAndReasons }}
          </div>
        </div>
        <!-- 证据材料 -->
        <div class="star-title">
          <span class="star"></span>证据材料
        </div>
        <div class="search-items search ">
          <div class="search-item zhengjuBigbox">
            <div class="search-label">
              提交相关具体材料：
            </div>
            <div class="fileList cailiao">
              <div v-for="(item, index) in fileList1" :key="index" class="fileList-item">
                <el-tooltip class="fileList-itemText" effect="light" :content="item.originName" placement="top-start">
                  <span class="zhengju">{{ item.originName }}</span>
                </el-tooltip>
                <div @click="downLoad(item)" class="download-btn download-btn1">
                  下载
                </div>
                <div
                  v-if="item.showType !== 'wav' && item.showType !== 'rar' && item.showType !== 'txt' && item.showType !== 'aiff' && item.showType !== 'pcm' && item.showType !== 'flac' && item.showType !== 'alac' && item.showType !== 'wma' && item.showType !== 'mp3' && item.showType !== 'ogg' && item.showType !== 'aac'"
                  @click="handlePreview(item)" class="download-btn">
                  预览
                </div>
                <div v-else class="kong-btn" />
              </div>
            </div>
          </div>
          <div class="search-item science other">
            <div class="search-label">
              <p class="qita">其他补充材料：</p>
            </div>
            <div class="fileList fileList2">
              <div v-for="(item, index) in fileList2" :key="index" class="fileList-item">
                <el-tooltip class="fileList-itemText" effect="light" :content="item.originName" placement="top-start">
                  <span>{{ item.originName }}</span>
                </el-tooltip>
                <div @click="downLoad(item)" class="download-btn download-btn1">
                  下载
                </div>
                <div
                  v-if="item.showType !== 'wav' && item.showType !== 'rar' && item.showType !== 'txt' && item.showType !== 'aiff' && item.showType !== 'pcm' && item.showType !== 'flac' && item.showType !== 'alac' && item.showType !== 'wma' && item.showType !== 'mp3' && item.showType !== 'ogg' && item.showType !== 'aac'"
                  @click="handlePreview(item)" class="download-btn">
                  预览
                </div>
                <div v-else class="kong-btn" />
              </div>
            </div>
          </div>
          <!-- 网上告知 -->
          <div class="star-title" v-if="inform.length > 0">
            <span class="star" />网上告知
          </div>
          <div v-for="(ite, index) in inform" :key="index" class="applyInform-box">
            <p><span>【</span> 通知时间：{{ ite.noticeTime }} ，申请人查看时间：{{ ite.checkTime ? ite.checkTime : '--' }}
              <span>】</span>
            </p>
            <div>
              {{ ite.noticeContent }}
            </div>
          </div>
          <!-- 补正理由 -->
          <div class="star-title" v-if="inquireInfo.correctionReason">
            <span class="star" />相关补正说明
          </div>
          <div v-if="inquireInfo.correctionReason">
            {{ inquireInfo.correctionReason }}
          </div>
        </div>
        <div class="btnLists">
          <div v-if="status === 0 || status === 2" class="primary-btn" @click="revoke()">撤回</div>
          <div v-if="status === 2" class="primary-btn" @click="corrent()">复议申请补正</div>
          <div class="primary-btn" @click="$router.push('/codeSearch')">返回上一页</div>
        </div>
      </div>
    </div>
    <dialogPreview :applicantInfo="applicantInfo" ref="dialogPreview" />
    <revokeTip :caseOrderNo="caseOrderNo" :applicantInfo="applicantInfo" ref="revokeTip"
      @refreshDetail="refreshDetail" />
  </div>
</template>

<script>
import Api from '@api/api'
import dialogPreview from '@/components/dialogPreview/dialogPreview'
import revokeTip from './components/revokeTip'
export default {
  components: {
    dialogPreview,
    revokeTip
  },
  data () {
    return {
      applicantInfo: [
        {
          id: '',
          applicantCategory: '2',
          applicantName: '',
          gender: '',
          country: '',
          identificationType: '',
          identificationCard: '',
          identificationFile: '',
          bornDate: '',
          phone: '',
          telephone: '',
          addr: '',
          postcode: '',
          deliveryAddr: '',
          deliveryPostcode: '',
          sort: 1
        }
      ],
      respondentInfo: {},
      inquireInfo: {
        applyTime: ''
      },
      applyInfo: {},
      number: '',
      password: '', // 新建页面带过来 存在cookie中
      rePassword: '', // 接口返回 查询页直接进入
      countGR: 0,
      countFR: 0,
      status: 0,
      caseStatusText: '', // 案件状态（0未接收 2补正中 4已处理 5已撤回 9已退回）
      fileList1: [],
      fileList2: [],
      inform: [],
      caseInfo:{},
      caseOrderNo: ''
    }
  },
  mounted () {
    this.detail()
  },
  destroyed () {
    // 页面销毁密码
    // this.$cookie.remove('LoginPass') //补正跳转需要查看详情
  },
  methods: {
    corrent () {
      this.$router.push({
        name: 'oldNewCase',
        query: {
          number: this.number,
          name: 'DetailCase',
          opera: 1
        }
      })
    },
    revoke () {
      this.$refs.revokeTip.open()
    },
    refreshDetail () {
      this.detail()
    },
    // 获取详情
    detail () {
      this.number = this.$route.query.number
      this.fileList1 = []
      this.fileList2 = []
      if (this.$cookie.get('LoginPass')) {
        this.password = this.$cookie.get('LoginPass')
      }
      const p = {
        number: this.number, // 查询编码
        password: this.password
      }
      Api.oldDetail(p).then(res => {
        if (res.data.code === '0') {
          const data = res.data.data
          this.applicantInfo = data.applicantInfo
          this.countFR = data.countFR
          this.countGR = data.countGR
          this.applyInfo = data.applyInfo
          this.respondentInfo = data.respondentInfo
          this.inform = data.inform
          this.status = data.inquireInfo.caseStatus
          this.caseOrderNo = data.inquireInfo.caseOrderNo
          switch (data.inquireInfo.caseStatus) {
            case 0:
              this.caseStatusText = '未接收'
              break
            case 1:
              this.caseStatusText = '审理中'
              break
            case 2:
              this.caseStatusText = '补正中'
              break
            case 3:
              this.caseStatusText = '中止中'
              break
            case 4:
              this.caseStatusText = '已审结'
              break
          }
          this.inquireInfo = data.inquireInfo
          this.caseInfo = data.caseInfo
          this.rePassword = data.inquireInfo.inquirePwd
          this.password = data.inquireInfo.inquirePwd
          data.evidence.forEach(item => {
            if (item.kindType === 1) {
              this.fileList1.push(item)
            } else if (item.kindType === 2) {
              this.fileList2.push(item)
            }
          })
        } else {
          this.$router.push('/codeSearch')
        }
      })
    },
    // 身份证图片下载
    downLoad (item) {
      const p = {
        evidenceName: item.evidenceName,
        evidencePath: item.evidencePath
      }
      Api.downloadFile(p).then((res) => {
        console.log(res)
        const fileName = item.originName
        this.downLoadFile(fileName, res.data)
      })
    },
    // 文件下载
    downLoadFile (fileName, content) {
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, fileName)
      } else { // for Non-IE (chrome, firefox etc.)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = fileName
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    // 预览
    handlePreview (item) {
      console.log(item)
      const p = {
        evidencePath: item.showPath,
        evidenceType: item.showType,
        evidenceName: item.evidenceName
      }
      console.log(p)
      this.$refs.dialogPreview.open(p)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .fileList2{
    margin-top: 60px !important;
  }
  .zhengjuBigbox{
    width: 100% !important;
    .zhengju {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  }
  .main-contentBox .form-common .appinfo-box .applicat-search-items {
    padding: 20px 14px 20px 30px !important;
  }

  .contry {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .Identification {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .number .search-label {
    width: 80px !important;
  }

  .landline {
    margin-left: -15px;
  }

  .phoneNumber {
    margin-top: 40px;
  }

  .zxfy-titie {
    height: 60px !important;
    background-size: 180% 100% !important;
    background-position: center !important;
  }

  .main-contentBox {
    padding: 4px 10px 15px !important;
  }

  .search-label {
    text-align: left !important;
    margin-left: 20px !important
    // width: 80px !important;
  }

  .appinfo-box .col1-3 {
    width: 90%
  }

  .form-common .search-label {
    width: 130px !important;
    margin-left: 0 !important;
  }

  .download-btn {
    width: 80px !important;
    position: absolute !important;
    top: 200;
    margin-top: 45px;
    margin-left: -5px !important;
  }

  .download-btn1 {
    width: 80px !important;
    position: absolute !important;
    top: 100;
    margin-left: 80px !important;
  }

  .birthday {
    margin-top: 45px;
  }

  .phone {
    margin-left: 15px;
  }

  .dp-dialog {
    width: 300px !important;

    .el-dialog {
      width: 300px !important;
    }
  }

  .el-dialog__wrapper {
    margin: auto;
  }

  .info .search-label {
    width: 120px !important;
    margin-bottom: 10px;
  }

  .reason .search-label {
    width: 120px !important;

  }

  .evidence {
    position: relative;

    .search-label {
      width: 140px !important;
    }

    //  .download-btn{
    //   position: absolute;
    //   top: -10px !important;
    //   left: 8px;
    //   }
  }

  .science .search-label {
    margin-top: 30px !important;
  }

  .fileList {
    // position: absolute;
    margin-left: -160px !important;
    margin-top: 40px;
    left: 20px;
    width: 80% !important;

    .fileList-item {
      width: 90%;
      margin-bottom: 30px;

      .el-tooltip .fileList-itemText {
        line-height: 20px !important;
      }
    }

    .download-btn {
      margin-top: 30px;
      // margin-left: -20px;
      margin-left: -230px !important;
    }

    .download-btn1 {
      margin-top: 30px;
      // margin-left: -20px;
      margin-left: -50px !important;
    }

    // margin-left: -100px;

  }

  .cailiao {
    width: 100%;
    min-height: 20px !important;
    // background-color: pink;
  }

  .other {
    margin-top: -20px;
    width: 100% !important;

    .fileList-item {
      width: 90%;
      margin-bottom: 30px;
      margin-top: 10px;

      .el-tooltip .fileList-itemText {
        line-height: 20px !important;
      }
    }
  }
}

.zxfy-titie {
  background: url('~@/assets/images/zxfy-titie.png') no-repeat;
  height: 100px;
  background-size: 100% 100%;
}

.main-contentBox {
  background: linear-gradient(180deg, #FFFFFF 0%, #F5F8FE 100%);
  box-shadow: 5px 5px 20px 5px rgba(195, 195, 195, 0.09);
  padding: 20px 100px 60px;
  font-size: 14px;

  .star-title {
    margin-top: 30px;
    margin-bottom: 25px;
  }

  .addPerson {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;

    .addPerson-btn {
      width: 81px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: rgba(90, 137, 253, 0.08);
      border-radius: 4px;
      font-size: 14px;
      border: 1px solid rgba(90, 137, 253, 0.25);
      margin-right: 15px;
    }
  }

  .form-common {
    .appinfo-box {
      background: rgba(90, 137, 253, 0.02);
      box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
      border-radius: 0px 0px 4px 4px;
      backdrop-filter: blur(20px);
      margin-top: 24px;

      .typeTitle {
        background: url('~@/assets/images/applytitle.png') no-repeat;
        width: 100%;
        height: 52px;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;

        .typeTitle-name {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #333333;
          line-height: 53px;
        }
      }

      .applicat-search-items {
        padding: 20px 30px;

        .search-item {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }

  .search-label {
    width: 140px;
  }

  .search {
    flex-direction: column;
    line-height: 24px;
  }

  .title-no {
    flex-direction: row;
    display: flex;

    .title-no-left {
      width: 80%;
    }

    .title-no-right {
      width: 20%;
    }

    .reback {
      border: 4px solid red;
      color: red;
      width: 90px;
      height: 90px;
      border-radius: 50%;
      font: 20px Arial, sans-serif;
      justify-content: center;
      align-items: center;
      text-align: center;
      display: flex;
    }
  }

  .fileList {
    width: 50%;
    display: flex;
    flex-direction: column;

    .fileList-item {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: center;

      .fileList-itemText {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
      }
    }
  }

  .kong-btn {
    width: 64px;
    margin-left: 10px;
  }

  .download-btn {
    display: inline-block;
    background-color: #5A9CFF;
    height: 24px;
    width: 64px;
    line-height: 23px;
    color: white;
    border-radius: 3px;
    font-size: 12px;
    margin-left: 10px;
    text-align: center;
    cursor: pointer;
  }

  .respondentInfo-box {
    max-height: 100px;
    display: flex;
    flex-wrap: wrap;
    line-height: 26px;
    overflow: auto;
  }

  .applyInform-box {
    margin-bottom: 15px;
    line-height: 23px;
  }

  .primary-btn {
    margin-left: 10px;
  }
}
</style>
